import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from '../types';

import { FeedbackPageMode, FeedbackState } from './types';

export const getFeedbackState = (state: StoreState): FeedbackState =>
  state.feedback;

export const getAreFeedbacksActual = createSelector(
  getFeedbackState,
  feedback => feedback.mode === FeedbackPageMode.Actual,
);

export const getCurrentFeedback = createSelector(getFeedbackState, feedback =>
  feedback.rows.find(({ id }) => id === feedback.currentFeedbackId),
);
